module.exports = __webpack_public_path__ + "img/map.6a953ff9.svg";